angular.module('applications').service('EulaModalService', function($modal){

    var result = {};
    result.initModal = function()
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/eulaModal/eulaModal.html?v=" + versionNo,
            controller: "EulaController",
            backdrop: 'static',
            keyboard: false

        });
    }
    return result;
});